module.exports = __webpack_public_path__ + "static/img/es-sfss.bd35c1c2.png";